import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
/** @jsx jsx */

import { jsx } from '@emotion/core';
import { menuGroupCSS } from '../internal/styles/menu-section/menu-group';

var MenuGroup = function MenuGroup(_ref) {
  var maxWidth = _ref.maxWidth,
      minWidth = _ref.minWidth,
      minHeight = _ref.minHeight,
      maxHeight = _ref.maxHeight,
      testId = _ref.testId,
      rest = _objectWithoutProperties(_ref, ["maxWidth", "minWidth", "minHeight", "maxHeight", "testId"]);

  return jsx("div", _extends({
    css: menuGroupCSS({
      maxHeight: maxHeight,
      maxWidth: maxWidth,
      minHeight: minHeight,
      minWidth: minWidth
    }),
    "data-testid": testId
  }, rest));
};

export default MenuGroup;